module.exports = __webpack_public_path__ + "assets/retina_LReflectionDetailed.c9d47d56a4831f534457973cc26466e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_LReflectionDetailed.png
// module id = 687
// module chunks = 0